<template>
    <rkm-overlay>
        <rkm-layout-body :title="`${id ? 'Edição' : 'Cadastro'} de transferência`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save(model.finalizada)"
                    color="primary"
                >
                    Salvar
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save(model.finalizada, true)"
                    color="primary"
                >
                    Salvar e imprimir
                </rkm-button>

                <template v-if="model && !model.finalizada">
                    <rkm-button
                        @click="$refs.Form.finalizar()"
                        color="outline-success"
                    >
                        Finalizar
                    </rkm-button>
                </template>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @model-load="model = $event"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/almoxarifado/transferencia/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    data: () => ({
        model: null,
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.redirectToList()
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'almoxarifado-transferencia-index' })
        }
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>